// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { baseUrl } from '../../../../../app.config'

// ** Axios Imports
import axios from 'axios'
import toast from 'react-hot-toast'

export const getDealsList = createAsyncThunk(
    'businessDeals/getDealsList',
    async (params) => {

        const response = await axios.get(baseUrl() + '/company/getdeals', { params })
        console.log("getDealsList response", response)

        return {
            totalPages:
                response.data.pagination.totalCount,            // params: response.data.params,
            data: response.data.deals
        }
    }
)

export const getCategoryList = createAsyncThunk(
    'businessDeals/getCategoryList',
    async (params) => {
        const response = await axios.get(baseUrl() + '/mainCategory', { params })
        console.log("response", response.data)
        return {
            totalPages: response.data.count.total,
            //params: response.data.params,
            categoryList: response.data.data,
            //filterParams: params
        }
    }
)

export const getLocationList = createAsyncThunk(
    'businessDeals/getLocationList',
    async (params) => {
        const response = await axios.get(baseUrl() + '/locations', { params })
        return {
            totalPages: response.data.count.total,
            params: response.data.params,
            data: response.data.result
        }
    }
)

export const allBusinessList = createAsyncThunk(
    'businessDeals/allBusinessList',
    async (params) => {
        const response = await axios.get(baseUrl() + '/feed', { params })
        return {
            params: response.data.params,
            allBusinessList: response.data.result
        }
    }
)

export const addDeal = createAsyncThunk(
    'businessDeals/addDeal',
    async ({ payload, params }, { dispatch, getState }) => {
        console.log("addDeal", params)

        try {
            await axios.post(baseUrl() + '/company/deals', payload)
            toast.success('Deal Created Successfully')
            await dispatch(getDealsList(params))
            return true
        } catch (error) {
            toast.error(error?.response?.data?.message)
            return false
        }
    }
)

export const updateDeal = createAsyncThunk(
    'businessDeals/updateDeal',
    async ({ id, payload, params }, { dispatch, getState }) => {
        console.log("updateDeal", params)

        try {
            await axios.put(baseUrl() + `/company/update-deal/${id}`, payload)
            toast.success('Deal Updated Successfully')
            await dispatch(getDealsList(params))
            return true
        } catch (error) {
            toast.error(error?.response?.data?.message)
            return false
        }
    }
)

export const deleteDeal = createAsyncThunk(
    'businessDeals/deleteDeal',
    async ({ id, params }, { dispatch, getState }) => {
        try {
            await axios.delete(baseUrl() + `/company/delete/deal/${id}`),
                toast.success('Deal Deleted Successfully')
            await dispatch(getDealsList(params))
            return true
        } catch (error) {
            toast.error(error?.response?.data?.message)
            return false
        }
    }
)

export const businessDeals = createSlice({
    name: 'businessDeals',
    initialState: {
        dealList: [],
        allBusinessList: [],
        locationList: [],
        categoryList: [],
        reload: false,
        loader: false,
        rowsPerPage: 10,
        currentPage: 1,
        totalPages: 0,
        selected: null,
        clearFilter: false,
        status: '0',
        loading: false,
        params: {
            pageNo: 1,
            pageSize: 10
        },
        rowType: 'row1'


    },
    reducers: {
        selectBusinessDeals: (state, action) => {
            if (action.payload === null) {
                state.selected = null
            } else {
                state.selected = action.payload
            }
        },
        selectCurrentPage: (state, action) => {
            if (action.payload === null) {
                state.currentPage = null
            } else {
                state.currentPage = action.payload
            }
        },
        selectRowsPerPage: (state, action) => {
            if (action.payload === null) {
                state.rowsPerPage = null
            } else {
                state.rowsPerPage = action.payload
            }
        },
        selectClearFilter: (state, action) => {
            state.clearFilter = action.payload
        },
        setStatus: (state, action) => {
            state.status = action.payload
        },
        setLoader: (state) => {
            state.loader = !state.loader
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        },
        setParams: (state, action) => {
            state.params = {
                ...state.params,
                ...action.payload
            }
        },
        setRowType: (state, action) => {
            state.rowType = action.payload
        }
    },

    extraReducers: {
        [addDeal.fulfilled]: (state, action) => {
            state.reload = !state.reload
        },
        [getDealsList.fulfilled]: (state, action) => {
            state.dealList = action.payload.data
            state.totalPages = action.payload.totalPages
            state.loader = false
        },
        [allBusinessList.fulfilled]: (state, action) => {
            state.allBusinessList = action.payload.allBusinessList
        },
        [getCategoryList.fulfilled]: (state, action) => {
            state.categoryList = action.payload.categoryList
        },
        [getLocationList.fulfilled]: (state, action) => {
            state.locationList = action.payload.data
        },
        [updateDeal.fulfilled]: (state, action) => {
            state.reload = !state.reload
            state.loader = false
        },
    }
})

export const { selectBusinessDeals, selectRowsPerPage, selectCurrentPage, setStatus, setLoader,
    setLoading, selectClearFilter, setRowType, setParams } = businessDeals.actions

export default businessDeals.reducer
